import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { typography } from "../styles/designSystem";

const FooterWrapper = styled.footer`
  padding: 2.5rem 1rem;
  background-color: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.subtleText};
  text-align: center;
  font-family: ${typography.fontFamily.display};
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: ${typography.letterSpacing.wider};
  border-top: 1px solid ${({ theme }) => theme.borderMedium};

  @media (max-width: 768px) {
    font-size: 0.68rem;
    letter-spacing: 0.1em;
  }
`;

const Row = styled.div`
  margin: 0.6rem 0;
`;

// The ROBCO plate — the line every Fallout terminal boots with.
const Plate = styled.div`
  color: ${({ theme }) => theme.primary};
  text-shadow: 0 0 8px ${({ theme }) => theme.glow};
  margin-bottom: 1.25rem;
`;

const Links = styled.div`
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex-wrap: wrap;
  margin: 1.25rem 0 0.6rem;
`;

const Link = styled.a`
  color: ${({ theme }) => theme.primary};
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;

  &::before {
    content: "[";
    opacity: 0.5;
  }

  &::after {
    content: "]";
    opacity: 0.5;
  }

  &:hover {
    text-shadow: 0 0 10px ${({ theme }) => theme.glow};
  }
`;

const Footer = () => (
    <FooterWrapper>
        <Plate>ROBCO Industries (TM) Termlink Protocol</Plate>
        <Row>
            &copy; {new Date().getFullYear()} Nicholas Lovett &mdash; Senior Software Engineer
        </Row>
        <Links>
            <Link
                href="https://linkedin.com/in/nicholaslovett"
                target="_blank"
                rel="noopener noreferrer"
            >
                <FontAwesomeIcon icon={faLinkedin} /> LinkedIn
            </Link>
            <Link
                href="https://github.com/newlogicd3sign/portfolio"
                target="_blank"
                rel="noopener noreferrer"
            >
                <FontAwesomeIcon icon={faGithub} /> Source
            </Link>
        </Links>
        <Row>Built in React &middot; Deployed on Netlify</Row>
    </FooterWrapper>
);

export default Footer;
